const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneDeli(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13 3C15.3869 3 17.6761 3.94821 19.364 5.63604C21.0518 7.32387 22 9.61305 22 12",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7C14.3261 7 15.5979 7.52678 16.5355 8.46447C17.4732 9.40215 18 10.6739 18 12",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2404 16.8396C14.4366 16.9297 14.6576 16.9503 14.8671 16.898C15.0766 16.8456 15.262 16.7235 15.3927 16.5517L15.73 16.11C15.907 15.874 16.1365 15.6825 16.4003 15.5506C16.6641 15.4187 16.955 15.35 17.25 15.35H20.1C20.6039 15.35 21.0872 15.5502 21.4435 15.9065C21.7998 16.2628 22 16.7461 22 17.25V20.1C22 20.6039 21.7998 21.0872 21.4435 21.4435C21.0872 21.7998 20.6039 22 20.1 22C15.5648 22 11.2153 20.1984 8.00847 16.9915C4.8016 13.7847 3 9.4352 3 4.9C3 4.39609 3.20018 3.91282 3.5565 3.5565C3.91282 3.20018 4.39609 3 4.9 3H7.75C8.25391 3 8.73718 3.20018 9.0935 3.5565C9.44982 3.91282 9.65 4.39609 9.65 4.9V7.75C9.65 8.04497 9.58132 8.33588 9.44941 8.59971C9.3175 8.86353 9.12597 9.09302 8.89 9.27L8.4454 9.60345C8.271 9.73662 8.14807 9.92606 8.0975 10.1396C8.04693 10.3531 8.07184 10.5776 8.168 10.7748C9.46635 13.4119 11.6017 15.5446 14.2404 16.8396Z",
    stroke: "#868686",
    style: {
      stroke: "#868686",
      stroke: "color(display-p3 0.5255 0.5255 0.5255)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDeli);
export default __webpack_public_path__ + "static/media/phone_deli.63ed724e61ec05fa26dc45e0aee8e129.svg";
export { ForwardRef as ReactComponent };